import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
  CardImg,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone";
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";


const AddSideDrawer = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const ServiceTypeOptions = [
    { label: "Makan Master", value: "makan-master" },
    { label: "End of Trip", value: "endoftrip" },
    { label: "Events", value: "events" },
    { label: "Facilities", value: "facilities" },
  ];
  const frxAppOptions = [
    { label: "Digital Gift Cards", value: "digital_gift_card" },
    { label: "eStore", value: "StoreMainScreen" },
    { label: "Makan Master", value: "MakanMasterHome" },
    { label: "Rewards", value: "RewardsTab" },
    { label: "No Navigation", value: "" },
  ];


  const [title, setTitle] = useState("");
  // const [imageUrl, setImageUrl] = useState();
  const [position, setPosition] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const[navObj,setNavObj]=useState()
  const [selectedFRXSection, setselectedFRXSection] = useState(
    frxAppOptions[frxAppOptions.length - 1]
  );
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      const data = props?.location?.state?.item;
      let navObj = data ? data?.navigate_to : "";
      var title =props.location.state?.item?.menu_name
      // var imageUrl = props.location.state?.item?.iconFile;
      var position = props.location.state?.item?.sort_order;
      var status = props.location.state?.item?.item_status;
      setTitle(title)
      setNavObj(navObj)
      // setImageUrl(imageUrl);
      setPosition(position);
      setStatus(status);
    }
  }, []);

  const handleSubmit = () => {
    if (!title) {
      setErrorMessage("Please Enter Menu Name");
      setErrorAlert(true);
      return;
    }else if (!position) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    }
    //  else if (selectedFiles.length < 1) {
    //   setErrorMessage("Please select image");
    //   setErrorAlert(true);
    //   return;
    // }
     else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    } 
    setLoader(true)
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "sidedrawer/add");
    formdata.append("item_type","sidedrawer")
    formdata.append("created_datetime", currentDate);
    formdata.append("sort_order", position);
    formdata.append("menu_name", title);
    formdata.append("navigate_to", navObj);
    // formdata.append("iconFile", selectedFiles[0], selectedFiles[0].path);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    if (!title) {
      setErrorMessage("Please Enter Menu Name");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    } else if (!position) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    }

    setLoader(true)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    // myHeaders.append(
    //   "Cookie",
    //   "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    // );

    var formdata = new FormData();
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append("path","sidedrawer/update");
    formdata.append("item_type","sidedrawer")
    formdata.append("navigate_to", navObj);
    formdata.append("menu_name", title);
    // if (!imageUrl) {
    //   formdata.append("iconFile", selectedFiles[0], selectedFiles[0].path);
    // }
    formdata.append("sort_order", position);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      mimeType: "multipart/form-data",
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/sidedrawer");
        }}
        onConfirm={() => {
          props?.history.push("/sidedrawer");
          setSuccesAlert(false);
          setLoader(false)
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >

        {props?.location?.state?.edit?"SideDrawer Updated":" New SideDrawer Added"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (
      path == "jpg" ||
      path == "jpeg" ||
      path == "JPEG" ||
      path == "JPG" ||
      path == "png" ||
      path == "PNG"
    ) {
      setSelectedFiles(files);
      // setImageUrl("");
    } else {
      setErrorMessage("Please select a .jpg or .png file");
      setErrorAlert(true);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add SideDrawer" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  onChange={(e) => {
                                    setPosition(e.target.value);
                                  }}
                                  type="number"
                                  id="sort_input"
                                  defaultValue={position}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Menu Name</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setTitle(e.target.value);
                                }}
                                defaultValue={title}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={6} sm={10}>
                            <div className="mb-3">
                              <Label>Navigate To</Label>
                              <textarea
                              rows="4" 
                              cols="33"
                                type="text"
                                className="form-control"
                                id="nav_obj_input"
                                onChange={(e) => {
                                  setNavObj(e.target.value);
                                }}
                                defaultValue={navObj}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    {/* <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <Card>
                              <CardBody>
                                <Form>
                                  {imageUrl && (
                                    <Row>
                                      <Col md={1}>
                                        <CardImg
                                          className="img-fluid"
                                          src={imageUrl}
                                          style={{
                                            marginBottom: 15,
                                            width: "50px",
                                          }}
                                          alt=""
                                        />
                                      </Col>
                                      <Col md={2} style={{marginTop:"auto", marginBottom:"auto"}} >
                                        <div
                                        style={{cursor:"pointer"}}
                                          className="px-3 text-danger"
                                          onClick={() => {
                                            setImageUrl("");
                                          }}
                                        >
                                          <FaRegTrashAlt />Move To Trash
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      // validateFileSize(acceptedFiles)
                                      handleAcceptedFiles(acceptedFiles);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted"/>
                                          </div>
                                          <h4>
                                            Drop files here or click to upload.
                                          </h4>

                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {selectedFiles.map((f, i) => {
                                      return (
                                        <Card
                                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                          key={i + "-file"}
                                        >
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                              </Col>
                                              <Col>
                                                <Link
                                                  to="#"
                                                  className="text-muted font-weight-bold"
                                                >
                                                  {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                  <strong>
                                                    {f.formattedSize}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                </Form>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card> */}
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                        </Row>
                      </CardBody>
                    </Card>

                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/sidedrawer");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                       disabled={loader}
                       style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                       className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddSideDrawer;
